import { useRef } from 'react';
import { isUndefined, isFunction } from '@okee-uikit/react-utils';
import { useRefCallback } from '../callback';
import { useForceUpdate } from '../misc';
export function useControllable(options) {
  var value = options.value,
      onChange = options.onChange,
      _options$defaultValue = options.defaultValue,
      defaultValue = _options$defaultValue === void 0 ? value : _options$defaultValue,
      _options$controlled = options.controlled,
      controlled = _options$controlled === void 0 ? !isUndefined(value) : _options$controlled;
  var forceUpdate = useForceUpdate();
  var valueRef = useRef(undefined);

  if (!valueRef.current) {
    var initialValue = isFunction(defaultValue) ? defaultValue() : defaultValue;
    valueRef.current = {
      value: initialValue
    };
  }

  if (controlled) {
    valueRef.current.value = value;
  }

  var setValueOrCallOnChange = useRefCallback(function (updater, event) {
    valueRef.current.value = isFunction(updater) ? updater(valueRef.current.value) : updater;

    if (!controlled) {
      forceUpdate();
    }

    onChange === null || onChange === void 0 ? void 0 : onChange(valueRef.current.value, event);
  });
  return [valueRef.current.value, setValueOrCallOnChange];
}